<script>

    let { yScale, yTicks = [-1, 0, 1], yLabels, width=500, margin} = $props();

    const classes = [-0.5, 0, 0.5]
    const classNames = ['nina', 'zero', 'nino'];

    // The topmost labeled tick gets the °C unit suffix
    const topLabel = $derived(yLabels?.length ? Math.max(...yLabels) : null);


</script>

{#if yScale}
    {#each yTicks as tick, i}
        {@const classHad = classes.includes(tick) ? classNames[classes.indexOf(tick)] : null}
        {@const suffix = tick === topLabel ? "°C" : ""}
        {@const prefix = tick > 0 ? '+' : ''}
        {#if yLabels.includes(tick)}
            <text x=0 y={yScale(tick) + margin.top - 4} class="tick-text">{prefix}{tick}{suffix}</text>
        {/if}
        
        <line x1=0 x2={width} y1={yScale(tick) + margin.top} y2={yScale(tick) +margin.top}  stroke-width=1 class={classHad}></line>
    {/each}
{/if}

<style lang='scss'>
    line {
        stroke: $gray3;
        &.zero {
            stroke: $gray7;
            stroke-width: 1.5;
        }
        &.nino {
            stroke: $nino-floor;
            stroke-width: 2;
        }
        &.nina {
            stroke: $nina-ceil;
            stroke-width: 2;
        }
    }
    .tick-text {
        fill: #999;
        font-size: 11px;
        // alignment-baseline: hanging;
    }
</style>